import styled from 'styled-components';

const MetalmaxContainerBody: any = styled.main`
  margin: 0;
  padding: 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export default MetalmaxContainerBody;